import { createIcon } from '@chakra-ui/icons';

export const OpenGrading = createIcon({
  displayName: 'OpenGrading',
  viewBox: '0 0 44 44',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
      <path
        d="M2.15625 24.0258C2.14924 38.7215 18.0534 47.9139 30.7838 40.5722C36.6976 37.1616 40.3401 30.8526 40.3368 24.0258C40.3438 9.33015 24.4397 0.137724 11.7093 7.4795C5.79547 10.8901 2.15303 17.199 2.15625 24.0258Z"
        fill="#FEF3DF"
      />
      <path
        d="M29.2735 17.3663C29.2732 16.3065 30.1323 15.4473 31.1921 15.4473H16.9937C15.722 15.4473 14.6911 16.4783 14.6914 17.75V39.2394H27.355C28.4145 39.2394 29.2735 38.3804 29.2735 37.3209V17.3663Z"
        fill="white"
      />
      <path
        d="M8.74365 39.6233C8.74365 40.3618 18.1739 40.8233 25.718 40.4541C29.2193 40.2827 31.3761 39.966 31.3761 39.6233C31.3761 38.8849 21.9459 38.4233 14.4018 38.7926C10.9005 38.9639 8.74365 39.2806 8.74365 39.6233Z"
        fill="#F6D59D"
      />
      <path
        d="M29.2735 17.3663C29.2732 16.3065 30.1323 15.4473 31.1921 15.4473H16.9937C15.722 15.4473 14.6911 16.4783 14.6914 17.75V39.2394H27.355C28.4145 39.2394 29.2735 38.3804 29.2735 37.3209V17.3663Z"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1113 17.3662C33.1109 16.1533 32 15.2445 30.8109 15.4844C29.8991 15.687 29.2559 16.5035 29.2723 17.4373V19.2853H32.4699C32.8231 19.2853 33.1094 18.999 33.1094 18.6458L33.1113 17.3662Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8976 23.1205C15.8979 23.5446 15.5542 23.8885 15.1302 23.8885H11.2911C10.7017 23.8443 10.3811 23.1785 10.714 22.6901C10.8457 22.497 11.0581 22.3744 11.2911 22.3569H15.1287C15.5517 22.3562 15.8955 22.6977 15.8976 23.1205Z"
        fill="#F6D59D"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8975 24.6575C15.8975 25.0814 15.5539 25.425 15.1301 25.425H11.291C10.7003 25.425 10.331 24.7855 10.6264 24.2739C10.7635 24.0364 11.0169 23.8901 11.291 23.8901H15.1287C15.5531 23.8891 15.8978 24.233 15.8975 24.6575Z"
        fill="#F6D59D"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1301 25.4248C15.1069 26.9019 13.4933 27.8 12.2258 27.0413C11.6559 26.7002 11.3029 26.0888 11.2925 25.4248H15.1301Z"
        fill="#F6D59D"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2679 25.7425L32.7799 36.5729C33.1234 36.9256 33.7199 36.7742 33.8536 36.3004C33.8695 36.2442 33.8775 36.1861 33.8776 36.1276V25.2973C33.8776 24.9441 33.5913 24.6578 33.2381 24.6577H22.727C22.2347 24.6577 21.9269 25.1906 22.173 25.6169C22.1993 25.6626 22.2312 25.7047 22.2679 25.7425ZM31.96 32.5067L26.2038 26.5763H31.96V32.5067Z"
        fill="#F6D59D"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7899 35.4019C26.0371 35.4049 26.1883 35.6745 26.062 35.8871C26.0454 35.9149 26.0248 35.94 26.0008 35.9616C24.9548 37.0049 25.4304 38.7892 26.8569 39.1734C27.0194 39.2172 27.187 39.2394 27.3552 39.2394H12.8438C11.9099 39.2558 11.0935 38.6126 10.8909 37.7008C10.6519 36.5121 11.5607 35.4022 12.7731 35.4019H25.7899Z"
        fill="white"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7614 15.4474C17.7614 12.7227 15.9363 10.8428 13.2116 10.8428C10.5948 10.7348 8.44401 12.8854 8.55173 15.5022C8.55173 17.8966 11.2377 20.4361 11.2377 22.3547H15.0754C15.0754 20.9845 17.7614 18.0207 17.7614 15.4474Z"
        fill="white"
      />
      <path
        d="M17.7614 15.4474C17.7614 12.7227 15.9363 10.8428 13.2116 10.8428C10.5948 10.7348 8.44401 12.8854 8.55173 15.5022C8.55173 17.8966 11.2377 20.4361 11.2377 22.3547H15.0754C15.0754 20.9845 17.7614 18.0207 17.7614 15.4474Z"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.7729 22.3569L11.0653 17.2316C10.852 16.5941 11.4089 15.9647 12.0677 16.0988C12.2361 16.133 12.3905 16.2162 12.5118 16.3378C12.8679 16.6931 13.4444 16.6931 13.8004 16.3378C14.2753 15.8618 15.0873 16.0784 15.2621 16.7276C15.3067 16.8934 15.3015 17.0688 15.247 17.2316L13.5403 22.3569"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.856 18.308L35.2631 17.9009"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.3618 19.5288H35.9374"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.856 20.75L35.2631 21.1566"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.6348 21.2554V21.8309"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.4135 20.75L32.0063 21.1566"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8833 9.66786V6.59814"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3486 8.1333H19.4183"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.86572 13.9128V12.3779"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.09814 13.145H6.63302"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5762 12.9533V11.4185"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8086 12.186H32.344"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.68758 22.0026C1.55625 22.2483 1.73454 22.5453 2.01311 22.5448H5.1124C5.39084 22.545 5.56913 22.2485 5.43836 22.0026L3.88824 19.0966C3.75455 18.8461 3.39975 18.8342 3.2496 19.0752C3.24525 19.0822 3.24115 19.0894 3.23728 19.0966L1.68758 22.0026Z"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2964 20.0522H26.5875"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7612 22.355H26.5876"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9937 26.96H20.4476"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9937 29.2622H22.7498"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9937 31.5649H25.4363"
        stroke="#453924"
        strokeWidth="0.44"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
